import { PlusIcon } from '@heroicons/react/24/outline';
import { Key } from '@phosphor-icons/react';
import { useState } from 'react';

import { QueriedList } from '@/components/list/QueriedList.tsx';
import { Button } from '@/components/ui/Button.tsx';
import DashboardHeader from '@/components/ui/layout/dashboard-layout/DashboardHeader.tsx';
import { APIKeyListItem } from '@/features/administrator-panel/api-keys/APIKeyListItem.tsx';
import { CreateAPIKeyDialog } from '@/features/administrator-panel/api-keys/CreateAPIKeyDialog.tsx';
import { listApiKeysInfiniteQuery } from '@/features/administrator-panel/api-keys/api/apiKeysApi';

export const API_KEYS_PER_PAGE = 10;

export const APIKeys = () => {
  const [createKeyDialogOpen, setCreateKeyDialogOpen] = useState(false);

  return (
    <>
      <DashboardHeader className={'flex items-center justify-center'}>
        <Key className={'mr-2 inline size-8 text-gray-800 '} />
        API Keys
      </DashboardHeader>

      <QueriedList
        query={listApiKeysInfiniteQuery(API_KEYS_PER_PAGE)}
        className={'mt-8'}
        label={'API Keys'}
        action={
          <Button
            size={'sm'}
            className={'mb-1'}
            onClick={() => setCreateKeyDialogOpen(true)}
          >
            <PlusIcon className={'mr-2 size-5'} />
            Create API Key
          </Button>
        }
      >
        {({ item }) => {
          return <APIKeyListItem apiKey={item} key={item.id} />;
        }}
      </QueriedList>

      <CreateAPIKeyDialog
        open={createKeyDialogOpen}
        onClose={() => setCreateKeyDialogOpen(false)}
      />
    </>
  );
};
